var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 24.7474H16.7839C17.5526 24.7474 18.1758 25.3706 18.1758 26.1393V42.8425C18.1758 43.6112 17.5526 44.2344 16.7839 44.2344H14",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1758 40.0586C28.3912 45.2449 27.8928 44.5615 36.6397 44.5615C40.3033 44.5615 42.149 42.1743 43.2263 38.6764V38.6541L45.8807 29.7458V29.7291C46.1351 28.8882 45.9776 27.9765 45.4557 27.2697C44.9339 26.5629 44.1091 26.1439 43.2305 26.1393H36.4101C35.5465 26.1394 34.7318 25.7386 34.2047 25.0546C33.6776 24.3705 33.4979 23.4806 33.7181 22.6456L34.9457 17.991C35.2395 16.8739 34.6903 15.7069 33.6423 15.2212C32.5943 14.7356 31.3489 15.0709 30.6864 16.0172L23.8827 25.6563C23.3612 26.3955 22.5129 26.8352 21.6083 26.8353H18.1758",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNps);
export default __webpack_public_path__ + "static/media/icon-nps.c46a7434.svg";
export { ForwardRef as ReactComponent };